module.exports = __webpack_public_path__ + "static/media/edit_hover.12055f20.svg";